module.exports = __webpack_public_path__ + "img/logo-argusblack-blanco.2ab8ca79.png";